(function ($) {


    $('.product__gallery-lightbox-zoom-target').on('click', function (e) {
        const $img = $(this);
        const $container = $img.closest('.panzoom');
        const isZoomed = $img.hasClass('zoomed');

        // Reset zoom u všech
        $('.product__gallery-lightbox-zoom-target').removeClass('zoomed').css('transform', '');

        if (isZoomed) return;

        // Kliknutí ve výchozí výšce obrázku
        const offset = $img.offset();
        const clickY = e.pageY - offset.top;
        const clickRatio = clickY / $img.height();


        // Zvětšení
        $img.addClass('zoomed');

        requestAnimationFrame(() => {
            const newHeight = $img.outerHeight(); // výška po zoomu
            const containerHeight = $container.height();

            const targetOffset = (newHeight * clickRatio) - (containerHeight / 2);
            const maxOffset = Math.max(newHeight - containerHeight, 0);

            const scrollTarget = Math.min(Math.max(targetOffset, 0), maxOffset);

            $container.scrollTop(scrollTarget);

        });

    });

})(jQuery);